<script setup lang="ts">
import CanvasButton from "@/components/canvas/CanvasButton.vue";
import DRDropdownItem from "@/components/UI/DRDropdownItem.vue";
import { DraggerType } from "@/drawing";
import { isCanvasDrawing } from "@/stores/CanvasViewState";

/**
 * Transformations depuis un point (maquettes V5) : copier, déplacer, pivoter
 * et mettre à l'échelle, réunies sous un seul bouton « Transformer ».
 */
const emit = defineEmits<{ (e: "select", tool: DraggerType): void }>();

const ACTIONS = [
  { tool: DraggerType.Copy, icon: "bi-crosshair", key: "copyToPoint" },
  { tool: DraggerType.Move, icon: "bi-arrows-move", key: "moveToPoint" },
  {
    tool: DraggerType.Rotate,
    icon: "bi-arrow-clockwise",
    key: "rotateAroundPoint",
  },
  {
    tool: DraggerType.Scale,
    icon: "bi-arrows-angle-expand",
    key: "scaleFromPoint",
  },
] as const;
</script>

<template>
  <!-- Téléporté dans body : s'estompe pendant un tracé comme sa barre -->
  <el-dropdown
    trigger="click"
    placement="top"
    :popper-class="isCanvasDrawing ? 'drawing-active' : ''"
  >
    <CanvasButton
      class="transform-btn px-2"
      icon="arrows-move"
      size="nosize"
      :tooltip-title="$t('canvas:selection.transform.tooltip.title')"
      :tooltip-text="$t('canvas:selection.transform.tooltip.text')"
    >
      <span class="selection-btn-label">{{
        $t("canvas:selection.transform.label")
      }}</span>
      <span class="transform-caret"></span>
    </CanvasButton>

    <template #dropdown>
      <el-dropdown-menu>
        <DRDropdownItem
          v-for="action in ACTIONS"
          :key="action.tool"
          :icon="action.icon"
          :label="$t(`canvas:selection.${action.key}.tooltip.title`)"
          @select="emit('select', action.tool)"
        />
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<style lang="scss" scoped>
.transform-btn {
  height: 36px;
  gap: 6px;
}

.selection-btn-label {
  font-size: 11px;
  font-weight: 500;
}

.transform-caret {
  width: 0;
  height: 0;
  border-top: 4px solid currentColor;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}
</style>
